export default __webpack_public_path__ + "static/media/fork.3ae3a9a4.png";